<template>
  <div>
    <div class="key-indicator">
      <div class="icon-key-indicator">
        <i :class="icon"></i>
      </div>
      <div :style="'color:' +  color + ';'" class="indicator">{{ value }}</div>
      <div style="">{{ name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["icon", "value", "name", "color"]
}
</script>

<style scoped>
.icon-key-indicator {
  font-size: 40px
}

.indicator {
  padding-top: 10px;
  font-size: 32px;
}

.key-indicator {
  text-align: center
}

@media screen and (max-width: 1080px) {
  .icon-key-indicator {
    font-size: 24px;
  }

  .indicator {
    font-size: 20px;
  }

}
</style>